import { NavigationPathsEnum } from "@utilities/enums";
import { useCategory, useNavigation, useProduct } from "@utilities/hooks";
import { useCallback, useEffect, useMemo, useState } from "react";

export const useController = () => {

    const { 
        categories, createCategoryLoading,
        createCategoryError, createCategorySuccess,
        getAllOrganisationCategoriesLoading,
        onGetAllOrganisationCategories,
        onCreateCategory,
    } = useCategory();
    const {
        createProductLoading,
        createProductError, createProductSuccess,
        onCreateProduct,
    } = useProduct();
    const { navigateTo } = useNavigation()
    const [activeTab, setActiveTab] = useState<Number>(1);

    useEffect(()=> {
        onGetAllOrganisationCategories();
    }, []);

    const tabs = useMemo(()=> [
        { index: 0, label: 'Personnalisation de la carte' },
        { index: 1, label: 'Ajouter un produit' },
        { index: 2, label: 'Ajouter une catégorie' },
    ], []);

    const handleTabSwitch = useCallback((tab: number) => {
        setActiveTab(tab);
    }, []);
    
    const handleBackClick = useCallback(() => {
        navigateTo(NavigationPathsEnum.STOCKS)
    }, [navigateTo]);

    return {
        createCategorySuccess, createProductSuccess,
        tabs, activeTab, createCategoryError,
        createProductLoading, createProductError,
        categories, createCategoryLoading,
        getAllOrganisationCategoriesLoading,
        handleTabSwitch, handleBackClick,
        onCreateCategory, onCreateProduct,
    }
}
